import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { redirectBackWithError } from "../lib/oauthUtils";
import { isInOauthFlow, isOauthAllowedPath, oauthCallbackDateAtom } from "../store/other";

export const URLSearchParamsHandler = () => {
  const location = useLocation();
  const setOauthCallbackDate = useSetAtom(oauthCallbackDateAtom);

  useEffect(() => {
    const url = new URL(window.location.href);
    const language =
      url.searchParams.get("lang") || url.searchParams.get("language");
    if (language) {
      localStorage.setItem("language", language);
    }
  }, [location.search]);

  useEffect(() => {
    const url = new URL(window.location.href);
    const cb = url.searchParams.get("cb");

    if (cb) {
      setOauthCallbackDate(Date.now());
    }
  }, [location.search, setOauthCallbackDate]);

  useEffect(() => {
    if (!isInOauthFlow()) {
      return;
    }
    if (!isOauthAllowedPath(location.pathname)) {
      redirectBackWithError("failed");
    }
  }, [location.pathname]);

  return null;
};
